import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const AlreadyAnsweredPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <h1>{t("alreadyAnswered.title")}</h1>
      <p>{t("alreadyAnswered.text")}</p>
    </div>
  );
};

export default AlreadyAnsweredPage;
